import { render, staticRenderFns } from "./VideoCallLayout.vue?vue&type=template&id=6bb95c49&scoped=true&"
import script from "./VideoCallLayout.vue?vue&type=script&lang=js&"
export * from "./VideoCallLayout.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallLayout.vue?vue&type=style&index=0&id=6bb95c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb95c49",
  null
  
)

export default component.exports